// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__32zN1","alertIcon":"ConfirmModal_alertIcon__4R9EF"};